import { notificationQueryKeys as e } from "./notificationQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { notificationsApi as n } from "@maat/api-notifications";
//#region src/notifications/useNotificationSettingsQuery.ts
var r = () => t({
	queryKey: e.settings(),
	queryFn: () => n.getNotificationSettings()
});
//#endregion
export { r as useNotificationSettingsQuery };
